import {
  PostNotificationInterface,
  DeleteNotificationInterface,
  UpdateNotificationInterface,
} from '@/data/payload/contracts/NotificationRequest'

export class UpdateNotificationRequest implements UpdateNotificationInterface {
  private title: string
  private content: string
  private isDeletable: string

  constructor(title: string, content: string, isDeletable: string) {
    this.title = title
    this.content = content
    this.isDeletable = isDeletable
  }
  public toJSON() {
    const data = {
      title: this.title,
      content: this.content,
      is_deletable: this.isDeletable,
    }
    return JSON.stringify({
      data,
    })
  }

  public toFormData(): FormData {
    const data = new FormData()
    data.append('title', this.title)
    data.append('content', this.content)
    data.append('isDeletable', this.isDeletable === 'true' ? '1' : '0')
    return data
  }
}
export class DeleteNotificationRequest implements DeleteNotificationInterface {
  private ids: number

  constructor(ids: any) {
    this.ids = ids
  }
  public toJSON() {
    const Ids = this.ids
    return JSON.stringify({
      Ids,
    })
  }
}

export class NotificationApiRequest implements PostNotificationInterface {
  private owner_type: string
  private owner_id: string
  private title: string
  private content: string
  private fileUpload: any
  private isDeletable: string
  private isMaterial: string
  private idMaterial: string
  private fileMaterial: string
  private notificationType : string
  private externalLink : string

  constructor(
    owner_type: string,
    owner_id: string,
    title: string,
    content: string,
    fileUpload: any,
    isDeletable: string,
    isMaterial: string,
    idMaterial: string,
    fileMaterial: string,
    notificationType : string,
    externalLink : string
  ) {
    this.owner_type = owner_type
    this.owner_id = owner_id
    this.title = title
    this.content = content
    this.fileUpload = fileUpload
    this.isDeletable = isDeletable
    this.isMaterial = isMaterial
    this.idMaterial = idMaterial
    this.fileMaterial = fileMaterial
    this.notificationType = notificationType
    this.externalLink = externalLink
  }

  public toJSON() {
    const data = {
      owner_type: this.owner_type,
      owner_id: this.owner_id,
      title: this.title,
      content: this.content,
      fileUpload: this.fileUpload,
      is_deletable: this.isDeletable,
      is_material: this.isMaterial,
      id_material: this.idMaterial,
      notification_type: this.notificationType,
      external_link: this.externalLink,
    }

    return JSON.stringify({
      data,
    })
  }

  public toFormData(): FormData {
    if (this.fileUpload === null || this.fileUpload === undefined) {
      const data = new FormData()
      data.append('ownerType', this.owner_type)
      data.append('ownerIds', this.owner_id)
      data.append('title', this.title)
      data.append('content', this.content)
      data.append('isDeletable', this.isDeletable === 'true' ? '1' : '0')
      data.append('fileMaterial', this.fileMaterial)
      data.append('isMaterial', this.isMaterial)
      data.append('idMaterial', this.idMaterial)
      data.append('notificationType', this.notificationType)
      data.append('externalLink', this.externalLink)
      return data
    } else {
      const data = new FormData()
      data.append('ownerType', this.owner_type)
      data.append('ownerIds', this.owner_id)
      data.append('title', this.title)
      data.append('content', this.content)
      data.append('fileUpload', this.fileUpload)
      data.append('isDeletable', this.isDeletable === 'true' ? '1' : '0')
      data.append('fileMaterial', this.fileMaterial)
      data.append('isMaterial', this.isMaterial)
      data.append('idMaterial', this.idMaterial)
      data.append('notificationType', this.notificationType)
      data.append('externalLink', this.externalLink)
      return data
    }
  }
}
